import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import { FormControlLabel, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import DataStore from "./../../../stores/DataStore";
import Tooltip from "@mui/material/Tooltip";
import { observer } from "mobx-react";

/**
 * @class
 * Attribut für Auswahl DropDown Anzeigen
 * @name DropDownAttribute
 * @implements {Attribute}
 */
class DropDownAttribute extends Component {
  constructor(params) {
    super(params);
    const { attribute: { attributeOption = {}, id = "", requestKey } = {} } =
      params;
    // if(requestKey){
    //   DataStore.requestStore.requests[requestKey].setState("toRequest")
    // }
    this.state = {
      choicesFromUrl: undefined,
    };
  }

  onChange(evt) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  getFields() {
    const { attribute: { attributeOption = {}, id = "", requestKey } = {} } =
      this.props;
    const { choices = [] } = attributeOption;
    if (requestKey) {
      return this.createFields(
        DataStore.requestStore.requests[requestKey].value
      );
    }
    return this.createFields();
  }

  setChoices(choices) {
    this.setState({ choicesFromUrl: choices });
  }

  getUsedChoices(pChoices) {
    const { attribute: { attributeOption = {} } = {} } = this.props;
    const { choices = [] } = attributeOption;
    let usedChoices = pChoices || choices;

    if (DataStore.attributeValues[this.id].updateOptions?.choices) {
      usedChoices = DataStore.attributeValues[this.id].updateOptions?.choices;
    }

    return usedChoices;
  }

  componentDidUpdate() {
    if (!this.id) return;
    const attrValue = DataStore.attributeValues[this.id];
    if (!attrValue) return;
    const usedChoices = attrValue.updateOptions?.choices;
    if (
      usedChoices &&
      attrValue.value !== undefined &&
      usedChoices.filter((c) => c.value == attrValue.value).length === 0
    ) {
      attrValue.setValue(undefined);
    }
  }

  renderFilterableAttribute({
    id,
    name,
    placeholder,
    FormCtrl,
    FormLabelProps,
    inputProps,
    noOptionsText,
  }) {
    const usedChoices = this.getUsedChoices();
    const selectedValue = DataStore.attributeValues[this.id].value;
    const selectedOption =
      usedChoices.find((c) => c?.value == selectedValue) || null;
    return (
      <FormCtrl style={{ flexGrow: 1, marginRight: "5px" }} {...FormLabelProps}>
        <Autocomplete
          key={id}
          disabled={DataStore.attributeValues[this.id].readOnly}
          options={usedChoices}
          value={selectedOption}
          getOptionLabel={(o) => o?.label || ""}
          isOptionEqualToValue={(o, v) => o?.value === v?.value}
          getOptionDisabled={(o) => o?.nopossibilities === 0}
          disableClearable
          noOptionsText={noOptionsText || "Keine Treffer gefunden"}
          onChange={(_, next) =>
            DataStore.attributeValues[this.id].setValue(next?.value)
          }
          renderOption={(props, option, { inputValue }) => {
            const effectiveInputValue = inputValue === (selectedOption?.label || "") ? "" : inputValue;
            const matches = match(option.label || "", effectiveInputValue, { insideWords: true });
            const parts = parse(option.label || "", matches);
            const highlighted = parts.map((part, index) =>
              part.highlight ? (
                <strong key={index} style={{ fontWeight: 700 }}>
                  {part.text}
                </strong>
              ) : (
                <span key={index}>{part.text}</span>
              )
            );
            return (
              <li {...props} key={option.value}>
                {option.tooltip ? (
                  <Tooltip title={option.tooltip}>{highlighted}</Tooltip>
                ) : (
                  highlighted
                )}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label={name}
              placeholder={placeholder}
              inputProps={{ ...params.inputProps, ...inputProps }}
            />
          )}
        />
      </FormCtrl>
    );
  }

  createFields(pChoices) {
    const { attribute: { id = "" } = {} } = this.props;
    const usedChoices = this.getUsedChoices(pChoices);
    const choicesList = [];
    usedChoices.forEach((c) => {
      const { label, value, tooltip, nopossibilities } = c;
      choicesList.push(
        <MenuItem
          value={value}
          key={id + value}
          disabled={nopossibilities === 0}
        >
          {tooltip ? (
            <Tooltip
              title={tooltip}
              value={c.value}
              key={id + c.value + "tooltip"}
            >
              <div>{label}</div>
            </Tooltip>
          ) : (
            label
          )}
        </MenuItem>
      );
    });
    return choicesList;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        placeholder = "",
        attributeOption: {
          choicesUrl,
          FormCtrl = FormControl,
          InputL = InputLabel,
          SelectC = Select,
          FormLabelProps = {},
          InputLabelProps = {},
          SelectProps = {
            variant: "standard",
          },
          inputProps: attributeInputProps = {},
          filterable = false,
          noOptionsText = "Keine Treffer gefunden",
          choices = [],
        },
        attributeModul,
      } = {},
    } = this.props;
    this.id = id;
    this.choicesUrl = choicesUrl;
    attributeModul.holdedAttribute = this;

    if (filterable) {
      return this.renderFilterableAttribute({
        id,
        name,
        placeholder,
        FormCtrl,
        FormLabelProps,
        inputProps: attributeInputProps,
        noOptionsText,
      });
    }

    const style = {
      opacity: DataStore.attributeValues[this.id].value ? "0" : "1",

      font: "inherit",
      color: "rgba(0, 0, 0, 0.6)",
      width: "100%",
      border: "0",
      height: "1.1876em",
      margin: "0",
      display: "block",
      padding: "6px 0 7px",
      minWidth: "0",
      background: "none",
      boxSizing: "content-box",
      animationName: "mui-auto-fill-cancel",
      letterSpacing: "inherit",
      animationDuration: "10ms",
    };
    return (
      <FormCtrl
        style={{
          flexGrow: 1,
          marginRight: "5px",
        }}
        {...FormLabelProps}
      >
        <InputL shrink id="demo-simple-select-label" {...InputLabelProps}>
          {name}
        </InputL>
        <SelectC
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          disabled={DataStore.attributeValues[this.id].readOnly}
          value={DataStore.attributeValues[this.id].value || ""}
          key={id}
          displayEmpty={placeholder !== ""}
          placeholder={placeholder}
          onChange={(evt) => this.onChange(evt)}
          inputProps={{ style: style }}
          {...SelectProps}
        >
          {/* {(placeholder !== "" ? [placeholderItem] : []).concat( */}
          {this.getFields()}
          {/* )} */}
        </SelectC>
      </FormCtrl>
    );
  }
}

export default observer(DropDownAttribute);
